import React from 'react';
import OfficeGlobalDataItem from '../../../Domain/OfficeGlobalDataItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import selectHelper from '../../../Helpers/selectHelper';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OfficeService from '../../../Services/OfficeService';

export default class OfficeGeneralEditPanelDescription extends React.Component {
  static titleForEdit = 'Edit Global Settings';
  static itemType = OfficeGlobalDataItem;
  static serviceFunction = OfficeService.EditGlobalOffice;

  //-----------------------------------------------------
  //---------------- Fields for General Edit Wizzard ----
  //-----------------------------------------------------

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'defaultMysteryShoppingPlatformPricingId',
          label: 'Default Mystery Shopping Platform Pricing',
          className: 'col-6',
          type: InputTypesEnum.MysteryShoppingPlatformPricingLookupSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'defaultCallRecordingCostId',
          label: 'Default Call Recording Cost',
          className: 'col-6',
          type: InputTypesEnum.CallRecordingCostLookupSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'defaultCsatcostId',
          label: 'Default CSAT Cost',
          className: 'col-6',
          type: InputTypesEnum.CsatCostLookupSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'defaultIvrcostId',
          label: 'Default IVR Cost',
          className: 'col-6',
          type: InputTypesEnum.IvrCostLookupSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'endOfMonthCutoffDay',
          label: 'EOM Cutoff Day *',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: OfficeGeneralEditPanelDescription.validityCheckerforTheEOMCutOffDate,
        },
        {
          fieldName: 'ddprejectSurcharge',
          label: 'DDP Reject Surcharge *',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'allowInvoiceFinalization',
          label: 'Allow Invoice Finalization',
          className: 'col-6',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'allowEndOfMonthAutomation',
          label: 'Allow End of Month Automation',
          className: 'col-6',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
          roleKey: 'officegeneral_editeomautomation',
        },
        {
          fieldName: 'maximumOpportunityDuration',
          label: 'Maximum Opportunity Duration (months) *',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'defaultInvoiceInterestRate',
          label: 'Default Invoice Late Fee %',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'evaluatorStatementDelay',
          label: 'Evaluator Statement Delay (hours) *',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'lateFeeGracePeriodInDays',
          label: 'Late Fee Grace Period In Days *',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'maximumIntervalInMonthsBetweenOpportunityEndDateAndProjectEndDate',
          label: 'Maximum Project End Date compared to Opportunity End Date (month) *',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'globalUserDeactivationDaysLimit',
          label: 'Global User Deactivation Days Limit',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'commissionRequiresCeoApprovalUserIds',
          label: 'Users that require CEO Approval for Commission',
          className: 'col-6',
          type: InputTypesEnum.ActiveUserMultiSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'eomPeriodEmailRecipientGroupId',
          label: 'Group that receives EOM Period Emails',
          className: 'col-6',
          type: InputTypesEnum.ActiveGroupSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
    {
      label: 'Mystery Shopping Platform Pricings',
      hide: (item) => item.mysteryShoppingPlatformPricings.length === 0,
      fields: [
        {
          fieldName: 'mysteryShoppingPlatformPricings',
          labelField: 'text',
          valueField: 'misc',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
      ],
    },
    {
      label: 'Call Recording Costs',
      hide: (item) => item.callRecordingCosts.length === 0,
      fields: [
        {
          fieldName: 'callRecordingCosts',
          labelField: 'text',
          valueField: 'misc',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
      ],
    },
    {
      label: 'CSAT Costs',
      hide: (item) => item.csatcosts.length === 0,
      fields: [
        {
          fieldName: 'csatcosts',
          labelField: 'text',
          valueField: 'misc',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
      ],
    },
    {
      label: 'IVR Costs',
      hide: (item) => item.ivrcosts.length === 0,
      fields: [
        {
          fieldName: 'ivrcosts',
          labelField: 'text',
          valueField: 'misc',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
      ],
    },
    {
      label: 'General Managers',
      fields: [
        {
          fieldName: 'globalBusinessDevelopmentManager',
          label: 'Global Business Development Manager',
          className: 'col-6',
          type: InputTypesEnum.ActiveUserSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'globalBusinessIntelligenceManager',
          label: 'Global Business Intelligence Manager',
          className: 'col-6',
          type: InputTypesEnum.ActiveUserSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'globalFinanceManager',
          label: 'Global Finance Manager',
          className: 'col-6',
          type: InputTypesEnum.ActiveUserSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'globalHumanResourcesManager',
          label: 'Global Human Resources Manager',
          className: 'col-6',
          type: InputTypesEnum.ActiveUserSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'globalInformationTechnologyManager',
          label: 'Global Information Technology Manager',
          className: 'col-6',
          type: InputTypesEnum.ActiveUserSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'globalMarketingManager',
          label: 'Global Marketing Manager',
          className: 'col-6',
          type: InputTypesEnum.ActiveUserSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'globalOperationsManager',
          label: 'Global Operations Manager',
          className: 'col-6',
          type: InputTypesEnum.ActiveUserSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'globalResourceManagementManager',
          label: 'Global Resource Management Manager',
          className: 'col-6',
          type: InputTypesEnum.ActiveUserSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'globalDataQualityManager',
          label: 'Global Data Quality Manager',
          className: 'col-6',
          type: InputTypesEnum.ActiveUserSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  //-----------------------------------------------------
  //--------- End of Fields for General Edit Wizzard ----
  //-----------------------------------------------------

  static getFrequencySelectOptions() {
    return selectHelper.generateSelectValues([
      '',
      'Daily',
      'Twice-a-week',
      'Weekly',
      'Fortnightly',
      'Monthly',
      'On-Demand',
    ]);
  }

  static validityCheckerforTheEOMCutOffDate(value, item) {
    if (parseInt(value) < 1 || parseInt(value) > 28) return 'Value has to be between 1 and 28.';
    return '';
  }
}
